module.exports = __webpack_public_path__ + "assets/img/places3.365f5563.jpg";